module.exports = __webpack_public_path__ + "img/2f_l_tomatsu@2x.8c66ae85.png";